import "vant/lib/index.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {
  Button,
  DropdownMenu,
  DropdownItem,
  Cell,
  Switch,
  Field,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Tag,
  Popup,
  ActionSheet
} from "vant";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./i18n";
import TopToastPlugin from "@/plugins/topToast";

Vue.component("van-field", Field);
Vue.component("van-button", Button);
Vue.component("van-dropdown-menu", DropdownMenu);
Vue.component("van-dropdown-item", DropdownItem);
Vue.component("van-cell", Cell);
Vue.component("van-switch", Switch);
Vue.component("van-checkbox-group", CheckboxGroup);
Vue.component("van-checkbox", Checkbox);
Vue.component("van-radio-group", RadioGroup);
Vue.component("van-radio", Radio);
Vue.component("van-tab", Tab);
Vue.component("van-tabs", Tabs);
Vue.component("van-tabbar", Tabbar);
Vue.component("van-tabbar-item", TabbarItem);
Vue.component("van-nav-bar", NavBar);
Vue.component("van-icon", Icon);
Vue.component("van-tag", Tag);
Vue.component("van-popup", Popup);
Vue.component("van-action-sheet", ActionSheet);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(TopToastPlugin);

(function saveInviteRefOnce() {
  try {
    if (typeof window === "undefined") return;

    const href = window.location.href || "";
    const afterHash = href.split("#")[1] || "";
    const searchPart = afterHash.split("?")[1] || "";
    const usp = new URLSearchParams(searchPart);
    const ref = usp.get("ref");

    if (ref && ref.startsWith("0x") && ref.length > 10) {
      localStorage.setItem("aetheria_invite_ref", ref);
    }
  } catch (e) {}
})();

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");